import * as React from "react";
import { renderInternalEvents } from "../renderInternalEvents";
import { LazyRender } from "sb-resp-ui";
import { Event } from "../../../../../contracts";
import { EventsFromTopLeaguesBySportIdRequest } from "sb-resp-lib";

export class RenderEvents extends React.PureComponent<{
    state: any,
    events: Event[],
    cmsSettings: any,
    dict: any,
    eventChunkHeights: number[]
}, {}> {

    render() {
        let view: any[] = [];
        const eventsLength = this.props.events.length;
        const eventToShow = Math.min(eventsLength, this.props.cmsSettings.ExpandedEvents);

        let currChunk = 0;
        for (let current = 0; current < eventToShow;) {
            let baseMinHeight = this.props.eventChunkHeights[currChunk++];

            let start = current;
            let max = current + this.props.state.EVENTS_CHUNK_SIZE;
            current = Math.min(max, eventToShow);

            view.push(
                <LazyRender
                    baseMinHeight={baseMinHeight}
                    key={`k-lazy-${current}`}
                    observerOptions={{
                        threshold: 0,
                        rootMargin: "100px 0px"
                    }}>
                    {renderInternalEvents(
                        this.props.state,
                        current,
                        start,
                        this.props.events,
                        this.props.cmsSettings,
                        this.props.dict
                    )}
                </LazyRender>);
        }

        let filteredEvents = this.props.events.filter(x => x.type === EventsFromTopLeaguesBySportIdRequest.EventTypesEnum.Outright.toString());

        eventToShow < eventsLength && !this.props.cmsSettings.ShowViewAllLive && !filteredEvents.length && view.push(this.props.children);

        return view;
    }

}